/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useCart } from "../useCart";
import { useDirectOrder } from "../useDirectOrder";

// A pending direct order takes precedence over the cart lines.
export function useOrderLines() {
  const { lines: cartLines } = useCart();
  const { line: directLine } = useDirectOrder();

  const isDirectOrder = !!directLine;

  return { lines: isDirectOrder ? [directLine] : cartLines, isDirectOrder };
}
